module.exports = __webpack_public_path__ + "static/media/qa.b63f6f25.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/qa.svg
// module id = 2196
// module chunks = 0